import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";
import clsx from "clsx";

import { marketAndroid, marketIos } from "../../../AppInstall";

import {
  GetVersionResponse,
  getVersion,
} from "../../../../services/etcServices";

import useAppVersion from "../../../../hooks/useAppVersion";
import { useDeviceType } from "../../../../hooks/useDeviceType/Index";
import useSimplePopup from "../../../../hooks/useSimplePopup";
import useLicense from "../../../../hooks/useLicense";
import useFullScreenLoading from "../../../../hooks/useFullScreenLoading";
import useStore from "../../../../hooks/useStore";

import StickyHeader from "../../../../components/Layout/StickyHeader";
import CommonButton from "../../../../components/Button";
import { MyInfoConfigRow } from "..";
import HorizontalRule from "../../../../components/Rule/Horizontal";
import TermsPopup from "../../../../components/Popup/Terms";

import SandiCi from "../../../../assets/img/sandi-ci.png";

type Props = {};

export default function AppInfo(props: Props) {
  const navigate = useNavigate();
  const deviceType = useDeviceType();
  const [appVersion, setAppVersion] = React.useState<GetVersionResponse>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [popup, setPopup] = useState<string>("");
  const [appVersionResult, versionCall] = useAppVersion();
  const [, licenseCall] = useLicense();
  const loadingComponent = useFullScreenLoading({
    isLoading,
  });
  const afterVersionCall = useRef<boolean>(false);
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [storeCall] = useStore({ open });

  const loadAppVersion = async () => {
    try {
      const res = await getVersion(
        deviceType.toLowerCase(),
        appVersionResult.result ?? ""
      );
      if (res.status === HttpStatusCode.Ok) {
        await setAppVersion(res.data);
      }
    } catch (e: any) {
      if (appVersionResult.result !== undefined) {
        setAppVersion({
          version: appVersionResult?.result,
        } as GetVersionResponse);
      } else {
        open("최신 버전 정보 조회에 실패했습니다.");
      }
    } finally {
    }
  };

  useEffect(() => {
    if (appVersionResult.isLoading) return;
    if (afterVersionCall.current === false) return;
    if (
      appVersionResult.isLoading === false &&
      appVersionResult.result === undefined
    ) {
      setIsLoading(false);
      return open("앱 버전 정보 조회에 실패했습니다.");
    }
    setIsLoading(true);
    loadAppVersion();
    setIsLoading(false);
  }, [deviceType, appVersionResult.isLoading, appVersionResult.result]);

  useEffect(() => {
    versionCall();
    afterVersionCall.current = true;
  }, []);

  return (
    <div>
      {loadingComponent}
      <StickyHeader
        title="앱 정보"
        onBackClick={() => navigate("/myinfo/config")}
        className="px-5"
      />

      <div className="flex flex-col gap-[30px] items-center">
        <div className="flex flex-col gap-[30px] items-center">
          <div className="py-[30px]">
            <img src={SandiCi} alt="ci" className="h-[100px]" />
          </div>
        </div>
        <div>
          현재 {appVersionResult?.result} / 최신 {appVersion?.version}
        </div>
        <CommonButton
          variant="tertiary"
          className={clsx([
            "text-sm font-medium text-brand-neutral-60",
            {
              "bg-brand-neutral-20 text-brand-primary-gray-100 !opacity-30 bg-none":
                appVersion?.version === appVersionResult?.result,
            },
          ])}
          onClick={() => {
            if (appVersion?.version === appVersionResult?.result) {
              open("이미 최신 버전입니다.");
            } else {
              if (deviceType === "Android") {
                storeCall("", marketAndroid);
              } else if (deviceType === "iOS") {
                storeCall("", marketIos);
              } else {
                open("데스크탑에서는 앱 연동은 미지원 상태입니다.");
              }
            }
          }}
        >
          최신버전 다운로드
        </CommonButton>

        <div className="w-full">
          <HorizontalRule margin="0" />
          <MyInfoConfigRow onClick={() => licenseCall()}>
            오픈소스라이선스
          </MyInfoConfigRow>
        </div>
      </div>

      <TermsPopup
        popup={popup}
        onClose={() => setPopup("")}
        type="openSource"
      />

      {simplePopupComponent}
    </div>
  );
}
